/* fy-video-testimonials — vídeos dos depoimentos:
   - carregam pausados exibindo a capa (poster) com botão de play;
   - play explícito toca COM som e pausa os demais vídeos da seção;
   - toque no vídeo alterna play/pause; ao sair de vista, pausa;
   - arquivos 16:9 com reel vertical + tarjas embutidas ganham zoom (CSS). */
(() => {
  if (customElements.get('fy-video-testimonials')) return;

  class FyVideoTestimonials extends HTMLElement {
    connectedCallback() {
      this.videos = [];

      this.querySelectorAll('[data-fy-video-card]').forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;
        this.videos.push(video);

        video.addEventListener('play', () => card.classList.add('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'));

        const playButton = card.querySelector('[data-fy-play]');
        if (playButton) {
          playButton.addEventListener('click', () => this.playVideo(video));
        }

        video.addEventListener('click', () => {
          if (video.paused) {
            this.playVideo(video);
          } else {
            video.pause();
          }
        });

        this.flagLandscape(video);
      });

      if (!this.videos.length) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
          });
        },
        { threshold: 0.3 }
      );
      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    playVideo(video) {
      this.videos.forEach((other) => {
        if (other !== video && !other.paused) other.pause();
      });
      video.muted = false;
      video.play().catch(() => {});
    }

    /* Arquivos horizontais (16:9) com reel vertical + tarjas pretas embutidas:
       marca para o CSS dar zoom e recortar as tarjas. */
    flagLandscape(video) {
      const check = () => {
        if (video.videoWidth > video.videoHeight) {
          video.classList.add('fy-video--pillarboxed');
        }
      };
      if (video.readyState >= 1) {
        check();
      } else {
        video.addEventListener('loadedmetadata', check, { once: true });
      }
    }
  }

  customElements.define('fy-video-testimonials', FyVideoTestimonials);
})();
